import React from "react"

import BaseLogoAndText, { Props } from "../../LogoAndText"

const LogoAndText = (props: Omit<Props, "idPrefix">) => {
  return <BaseLogoAndText {...props} idPrefix="footer" />
}

export default LogoAndText
